var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitephone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#C53EAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.4036C8 14.5227 15.4773 21.9987 19.5951 21.9987C20.0323 21.9987 20.8074 21.2152 21.0493 20.9116C22.4883 19.106 22.3136 18.9921 20.3893 17.7101C17.2966 15.6497 18.2324 16.9081 16.4184 17.3924C15.2664 16.6211 13.3776 14.7323 12.6063 13.5803C13.0841 11.7908 14.3257 12.6652 12.3523 9.70457C11.0289 7.71931 10.9446 7.46899 9.08713 8.94936C8.78353 9.19131 8 9.96642 8 10.4036Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitephone);
export default __webpack_public_path__ + "static/media/whitephone.342db937b31ceb21cb620b065aebec3f.svg";
export { ForwardRef as ReactComponent };